<template>
  <div class="info">
    <div class="product-box" :class="isnew===1?'isnew':'isold'">
      <div
        class="product-item"
        ref="ele"
        v-for="(item,index) in product.attrValue"
        :key="item.attrId"
        :class="[step>=index ? 'selected attr'+item.attrId : 'attr'+item.attrId]"
      >
        <div class="head">
          <label>{{index+1}}.{{item.attrName}}</label>
        </div>
        <div class="attrs" v-if="item.attrType===1" ref="attrs">
          <div
            class="item"
            v-for="value in item.valueList"
            :key="value.id"
            @click="onClick(index,value.id,value.value,item.attrId)"
            :class="attrs.indexOf(value.id)>-1 ? 'active':''"
          >{{value.value}}</div>
        </div>
        <div class="attrs" v-else>
          <div
            class="item"
            v-for="value in item.valueList"
            :key="value.id"
            @click="onCheck(value.id)"
            :class="attrs.indexOf(value.id)>-1 ? 'active':''"
          >{{value.value}}</div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
export default {
  props:["product"],
  data() {
    return {
      step: 0,
      realstep: 0,
      line: 0,
      count: 0,
      isnew: 2,
      attrs: [],
      // total: 1,
      attrid: 0,
      height:0,
    };
  },
  components: {},
  mounted:function(){
    // this.total = this.product.attrValue.length-1
  },
  methods: {
    toTop(height) {
      var gotoTop = function() {
        window.scrollTo(0, height);
        clearInterval(timer);
        timer = null;
      };
      var timer = setInterval(gotoTop, 300);
    },
    onClick(index, id, name, attrid) {
      let itemHeight = this.$refs.ele[index].offsetHeight;
      if (this.attrs[index] === undefined) {
        this.height +=itemHeight;
        this.attrs.push(id);
        this.step++;
        this.$emit("setStep", this.step);
        this.realstep++;
        // this.toTop(this.height);
      } else {
        this.attrs.splice(index, 1, id);
      }
      if (attrid === 9) {
        if (name.indexOf("全新") > -1) {
          this.step = this.product.attrValue.length-1 ;
          this.$emit("setStep", this.step);
          this.isnew = 1;
        } else {
          this.step = this.realstep;
          this.$emit("setStep", this.step);
          this.isnew = 2;
        }
      }
      this.$emit("getAttr", this.attrs);
    },
    onCheck(id) {
      let index = this.attrs.indexOf(id);
      if (this.attrs.indexOf(id) === -1) {
        this.attrs.push(id);
      } else {
        this.attrs.splice(index, 1);
      }
      this.$emit("getAttr", this.attrs);
    }
  }
};
</script>
<style scoped>
.product {
  width: 100%;
  height: auto;
  font-size: 14px;
  overflow: hidden;
  padding: 20px 0 50px 0;
}
.product-box {
  padding-top: 0rem;
  padding-bottom: 50px;
}
.isnew .attr4,.isnew .attr6,.isnew .attr7,.isnew .attr8,.isnew .attr10 {
  display: none;
}
.product-item {
  border-bottom: solid #efefef 1px;
  padding: 0px 15px;
}
.product-item .head {
  font-size: 14px;
  line-height: 30px;
  position: relative;
}
.product-item .head label {
  display: inline-block;
}
.product-item .attrs {
  display: flex;
  flex-wrap: wrap;
  display: none;
  padding-top:1px; 
}
.product-item.selected .attrs {
  display: block;
  display: flex;
}
.product-item .attrs .item {
  display: block;
  width: 200px;
  position: relative;
  border: solid #cfcfcf 1px;
  background: #fff;
  margin: 10px 0 10px 0rem;
  text-align: left;
  padding-left: 20px;
  margin-right: 20px;
  line-height: 42px;
  height: 42px;
  cursor: pointer;
  overflow: hidden;
}
.product-item .attrs .item:nth-child(2n) {
  
}
.product-item .attrs .item.active {
  background: #eff5ff;
  border: solid 1px #3782ff;
  color: #757575;
}
</style>